import React, { Fragment } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { actualizarUsuarioAtencionACliente, agregarUsuarioAtencionACliente, reasignacionDeCartera, verificarUsuario } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './AtencionAClienteFormComponent.module.css'
import { DataGrid } from '@mui/x-data-grid';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import moment from 'moment'
import { useSelector } from 'react-redux'
import { agregarHistorialCartera } from '../../../redux/DucksAtencionACliente/HistorialAtencionAClienteDucks'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 550,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const AtencionAClienteFormComponent = (props) => {

    const dispatch = useDispatch()
    let fechaHoy = new Date(moment().format('YYYY-MM-DD'))
    const dataUser = useSelector(store => store.Usuario.user)

    const usuarioModify = props.usuarioModify
    const carteras = props.carteras

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const rowsCarteras = []
    if (usuarioModify && carteras) {
        for (const cartera of carteras) {
            rowsCarteras.push({ id: cartera.idcartera, nombre: cartera.nombrecartera, })
        }
    }
    const columnsCarteras = [
        { field: 'nombre', headerAlign: 'center', headerName: 'Cartera', width: 200, headerClassName: estilos.headerColumn },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 150, headerClassName: estilos.headerColumn,
            renderCell: (params) =>
            (
                <div>
                    <button onClick={() => reasignarCartera(params)} className={`btn btn-outline-warning`} >Reasignar</button>
                </div>
            )
        },
    ]

    const reasignarCartera = async (data) => {
        await dispatch(reasignacionDeCartera({ cartera: data.row, usuarioModify }))
        handleClose()
        props.onClose()

    }
    const [initialStateFormik, setInitialStateFormik] = React.useState({
        id: '',
        nombre: '',
        apellidos: '',
        telefono: '',
        usuario: '',
        password: '',
        puesto: '',
        estatus: '',
        cartera: '',
    })

    React.useState(() => {
        if (usuarioModify !== null) {
            setInitialStateFormik({
                id: usuarioModify.iddatoslogin,
                nombre: usuarioModify.datoslogin.nombre,
                apellidos: usuarioModify.datoslogin.apellidos,
                telefono: usuarioModify.datoslogin.telefono,
                usuario: usuarioModify.usuario,
                password: usuarioModify.password,
                puesto: usuarioModify.idrol === 2 ? 'Ejecutivo' : usuarioModify.idrol === 1 ? 'Jefe de atención a cliente' : 'Recepcionista',
                cartera: usuarioModify.datoslogin.cartera.nombrecartera
            })
        }
    }, [usuarioModify])

    const validarEmail = (correo) => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) return false
        if (correo.match(emailRegex)) {
            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }
        }
        else {
            return false
        }

    }
    const agregarUsuario = async (values) => {
        const usuario = {
            nombre: values.nombre,
            apellidos: values.apellidos,
            telefono: values.telefono,
            usuario: values.usuario,
            password: values.password,
            puesto: values.puesto,
            cartera: values.cartera
        }
        const cartera = await dispatch(agregarUsuarioAtencionACliente(usuario))
        let fecha = new Date(fechaHoy).toISOString()
        const historial = {
            fecha: fecha,
            idaccion: 1,
            usuario: dataUser[0].usuario,
            idcartera: cartera.payload.datoslogin.idcartera,
            snapshot: usuario
        }
        await dispatch(agregarHistorialCartera(historial))
        return
    }
    const verificarUser = async (usuario) => {
        const user = await dispatch(verificarUsuario(usuario))
        return user.payload
    }
    const actualizarUsuario = async (values, usuarioModify) => {
        const usuario = {
            id: values.id,
            nombre: values.nombre,
            apellidos: values.apellidos,
            telefono: values.telefono,
            usuario: values.usuario,
            password: values.password,
            puesto: values.puesto,
            cartera: values.cartera
        }
        const data = {
            usuario,
            usuarioModify
        }
        const actualizarCartera = await dispatch(actualizarUsuarioAtencionACliente(data))
        let fecha = new Date(fechaHoy).toISOString()
        const historial = {
            fecha: fecha,
            idaccion: 3,
            usuario: dataUser[0].usuario,
            idcartera: actualizarCartera.payload.datoslogin.idcartera,
            snapshot: usuario
        }
        await dispatch(agregarHistorialCartera(historial))
    }
    const validarInputs = async (values) => {
        const errors = {};
        const textError = 'Campo obligatorio'
        if (!values.nombre) { errors.nombre = textError }
        if (!values.apellidos) { errors.apellidos = textError }
        if (!values.telefono) { errors.telefono = textError }
        else if ((values.telefono + '').length !== 10) { errors.telefono = 'Debe contener 10 digitos' }
        if (!values.usuario) { errors.usuario = textError }
        else {
            //let valido = validarEmail(values.usuario)
            //if (!values.usuario) errors.usuario = 'Verifica la estructura de tu correo electrónico'
            //else {
            if (usuarioModify) {
                if (values.usuario !== usuarioModify.usuario) {
                    const correoValidado = await verificarUser(values.usuario)
                    if (correoValidado) errors.usuario = 'El correo electrónico ya se encuentra registrado'
                }
            } else {
                const correoValidado = await verificarUser(values.usuario)
                if (correoValidado) errors.usuario = 'El correo electrónico ya se encuentra registrado'
            }
            //}
        }
        if (!values.password) { errors.password = textError }
        if (!values.puesto) { errors.puesto = textError }
        else if (values.puesto === 'default') { errors.puesto = textError }
        if (values.puesto === 'Ejecutivo' && !values.cartera) { errors.cartera = textError }

        return errors
    }
    return (
        <Fragment>
            <div className='row justify-content-center'>
                {/* ${estilos.contenedorBorder} */}
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `}>
                    <div className='row'>
                        <h2 className={`${estilos.tituloForm}`}>{
                            usuarioModify ?
                                "Editar Usuario Atención A Cliente" :
                                "Registrar Usuario Atención A Cliente"
                        }</h2>
                    </div>
                    <Formik
                        initialValues={initialStateFormik}
                        validate={async values => {
                            const errors = await validarInputs(values)
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            if (usuarioModify) {
                                await actualizarUsuario(values, usuarioModify)
                            } else {
                                await agregarUsuario(values)
                            }
                            setSubmitting(false);
                            props.onClose()
                        }}
                    >
                        {({ isSubmitting, values }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <label htmlFor="puesto">Puesto:</label><br />
                                            <Field as="select" name="puesto" className='form-control'>
                                                <option key='0' value='default'>Seleccione una opción</option>
                                                <option value='Jefe de atención a cliente'>Jefe de atención a cliente</option>
                                                <option value='Ejecutivo'>Ejecutivo de Atención a Cliente</option>

                                            </Field>
                                            <ErrorMessage name="puesto" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                    </div>

                                    {
                                        (values.puesto === 'Ejecutivo' || values.puesto === 'Jefe de atención a cliente') &&
                                        <div className='row'>
                                            <div className={usuarioModify ? 'col-md-9' : 'col-md-12'}>
                                                <label htmlFor="cartera">Nombre de la cartera:</label><br />
                                                <Field type="text" name="cartera" className='form-control'>
                                                </Field>
                                                <ErrorMessage name="cartera" component="div" className={`${estilos.error}`} /><br />
                                            </div>
                                            {
                                                usuarioModify &&
                                                <div className='col-md-3 mt-4 text-end'>
                                                    <button className='btn btn-sm btn-success' type='button' onClick={() => handleOpen()}>Reasignar cartera</button>
                                                </div>
                                            }
                                        </div>
                                    }


                                    <label htmlFor="nombre">Nombre:</label><br />
                                    <Field type="text" name="nombre" className='form-control'>
                                    </Field>
                                    <ErrorMessage name="nombre" component="div" className={`${estilos.error}`} /><br />

                                    <label htmlFor="apellidos">Apellidos:</label><br />
                                    <Field type="text" name="apellidos" className='form-control'>
                                    </Field>
                                    <ErrorMessage name="apellidos" component="div" className={`${estilos.error}`} /><br />

                                    <label htmlFor="telefono">Teléfono:</label><br />
                                    <Field type="number" name="telefono" className='form-control'>
                                    </Field>
                                    <ErrorMessage name="telefono" component="div" className={`${estilos.error}`} /><br />

                                    <label htmlFor="usuario">Correo electrónico:</label><br />
                                    <Field type="text" name="usuario" className='form-control'>
                                    </Field>
                                    <ErrorMessage name="usuario" component="div" className={`${estilos.error}`} /><br />

                                    <label htmlFor="apellidos">Contraseña:</label><br />
                                    <Field type="password" name="password" className='form-control'>
                                    </Field>
                                    <ErrorMessage name="password" component="div" className={`${estilos.error}`} /><br />

                                    <div className='text-center'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            {
                                                usuarioModify ?
                                                    "Guardar cambios" :
                                                    "Agregar usuario"
                                            }
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div>
                        <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={open}>
                                <Box sx={style}>
                                    <Typography id="modal-modal-title" variant="h4" component="h2" align='center'>
                                        Reasignación de cartera
                                    </Typography>
                                    <br /><br />
                                    <div className='row justify-content-center'>
                                        <div className='col-9 bg-white'>
                                            <div style={{ height: 400, width: '100%' }}>
                                                <DataGrid
                                                    rows={rowsCarteras}
                                                    columns={columnsCarteras}
                                                    pageSize={10}
                                                    rowsPerPageOptions={[10]}
                                                    sx={{
                                                        boxShadow: 0,
                                                        color: 'black',
                                                        border: 0,
                                                        '& .MuiDataGrid-cell': {
                                                            display: 'block',
                                                            position: 'relative',
                                                            textAlign: 'center',
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </Fade>
                        </Modal>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AtencionAClienteFormComponent)